import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { UnassignedBoxesEffects } from './effects/unassigned-boxes.effects';
import { UNASSIGNED_BOXES_FEATURE_KEY } from './keys';
import { unassignedBoxesReducer } from './reducers/unassigned-boxes.reducer';

export function provideUnassignedBoxesStore(): EnvironmentProviders[] {
    return [provideState(UNASSIGNED_BOXES_FEATURE_KEY, unassignedBoxesReducer), provideEffects(UnassignedBoxesEffects)];
}
